import { render, staticRenderFns } from "./EscalaFramingham.vue?vue&type=template&id=65a1b145"
import script from "./EscalaFramingham.vue?vue&type=script&lang=js"
export * from "./EscalaFramingham.vue?vue&type=script&lang=js"
import style0 from "./EscalaFramingham.vue?vue&type=style&index=0&id=65a1b145&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports